import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  // // console.log("parts", parts);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
// console.log("axios token", document.cookie);

axiosInstance.interceptors.request.use(
  (request) => {
    //const token = process.env.REACT_APP_USER_TOKEN;
    const token = getCookie("authToken");
    ///console.log(token);
    request.headers.Accept = "application/json";
    request.headers["Content-Type"] = "application/json";
    if(token)
      request.headers.Authorization = `Bearer ${token}`;
    return request;
  },
  (err) => {
    return Promise.reject(err);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return Promise.reject(err);
  }
);
